import { Component } from '@angular/core';

@Component({
  selector: 'groceriya-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'PPS';
}
